<template>
  <div>
    <van-grid
      :style="{ width: $vw(width) }"
      :column-num="3"
    >
      <van-grid-item
        v-for="icon in icons"
        :key="icon.id"
        @click="clickHandle(icon)"
      >
        <van-icon
          class="icon"
          :size="$vw('30px')"
          class-prefix="icon"
          color="var(--light40)"
          :name="icon.name"
        />
      </van-grid-item>
    </van-grid>
  </div>
</template>

<script>
import { Grid, GridItem } from 'vant'
import icons from '~/utils/iconName'

export default {
  name: 'ViaIconSelect',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  },
  props: {
    // rpx
    width: {
      type: Number,
      default: null
    },
    // 销毁
    clear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icons: [],
      timer: ''
    }
  },
  watch: {
    clear(newValue, oldValue) {
      if (!newValue) {
        this.destroyData()
      } else {
        this.initData()
      }
    }
  },
  mounted() {
    this.initData()
  },
  beforeDestroy() {
    this.destroyData()
  },
  methods: {
    // 实例化
    initData() {
      // 先加载200个图标
      this.icons = icons.slice(0, 200)
      // 开始异步加载
      let i = 1
      let _icons = this.icons
      this.timer = setInterval(() => {
        const arr = icons.slice(200 * i, 200 * (i + 1))
        if (!arr || arr.length === 0) {
          clearInterval(this.timer)
          return
        }
        _icons = _icons.concat(arr)
        this.icons = _icons
        ++i
      }, 1000)
    },
    // 注销数据
    destroyData() {
      clearInterval(this.timer)
      this.icons = []
    },
    clickHandle(icon) {
      this.$emit('click', icon)
    }
  }
}
</script>

<style scoped>

</style>
